import { httpService } from 'src/services/app/http.service'
import { AUTH_ENDPOINTS } from 'src/services/consts/api.const'
import { refactorPolicies } from 'src/services/helpers/policy.helper'

export const policyService = {
  loadPolicies,
}

async function loadPolicies() {
  const data = await httpService.post(AUTH_ENDPOINTS.LOAD_POLICIES)
  return refactorPolicies(data)
}
